/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import styled from 'styled-components';
import { Space, InputNumber, Button, Popover, Alert } from 'antd';
import { SaveOutlined, SendOutlined } from '@ant-design/icons';
import { SearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import * as L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-geosearch/assets/css/leaflet.css';
import i18next from "i18next";
import { maxBounds } from "../../../constants/map";
import { propHasValue } from "../../../components/DynamicFormNew/helper";

const Styles = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	width: 100%;
	.open-map {
		width: 100%;
    font-style: unset;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #001529;
    border: 1px solid #001529;
    box-sizing: border-box;
    border-radius: 8px;
	}
	.ant-popover-inner-content {
		padding: 0;
	}
`;

export default function Geolocation({
  val: value = {
    latitude: undefined,
    longitude: undefined,
  },
  onChange = () => { },
  allowClear = false,
  searchValue = ''
}) {
  const mapProvider = new OpenStreetMapProvider();
  const [mapId] = useState(Date.now());
  const [mapClass, setMapClass] = useState(null);
  const [posMarker, setPosMarker] = useState(null);
  const [mapVisible, setMapVisible] = useState(false);
  const [model, setModel] = useState({
    latitude: undefined,
    longitude: undefined,
  });

  const icon = new L.Icon({
    iconUrl: "/assets/images/map/position.png",
    iconSize: [20, 30]
  });

  useEffect(() => {
    if (value && propHasValue(value.latitude) && propHasValue(value.longitude)) {
      setModel(value);
    }
  }, [value])

  useEffect(() => {
    if (typeof model.latitude === 'number' && typeof  model.longitude === 'number') {
      if (mapClass) {
        const zoom = mapClass.getZoom() ? mapClass.getZoom() : 11;
        if (!posMarker) {
          setPosMarker(L.marker([model.latitude, model.longitude], {
            icon: icon,
          }).addTo(mapClass))
        } else {
          posMarker.setLatLng([model.latitude, model.longitude]);
        }
        mapClass.setView([model.latitude, model.longitude], zoom);
      }
      if (model.latitude !== value.latitude || model.longitude !== value.longitude) {
        onChange(model);
      }
    }
  }, [model]);

  useEffect(() => {
    if (mapVisible) {
      initMap();
    }
  }, [mapVisible, searchValue])

  const checkMarker = (lat, lng) => {
    if ((lng > -180 && lng < 180) && (lat > -85 && lat < 85)) {
      return true;
    }
    return false;
  }

  const initMap = () => {
    setTimeout(() => {
      if (!mapClass) {
        const map = L.map(document.getElementById(mapId), {
          maxZoom: 18,
          preferCanvas: true,
          doubleClickZoom: false,
          maxBounds: maxBounds,
        });
        setMapClass(map);
        L.control.scale().addTo(map)
        if (!model || !propHasValue(model.latitude) || !propHasValue(model.longitude) || !model.latitude || !model.longitude) {
          // map.getZoom();
          // map.setView([1.5743, 30.2397], zoom);
          searchForLocation(map);
        } else {
          const zoom = map.getZoom() ? map.getZoom() : 11;
          map.setView([model.latitude, model.longitude], zoom);
        }
        L.tileLayer(
          'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        ).addTo(map);
        const searchControl = new SearchControl({
          searchLabel: i18next.t('Search'),
          provider: mapProvider,
          style: 'button',
          notFoundMessage: i18next.t('Location not found'),
          showMarker: false,
          marker: {
            icon: icon,
          }
        });
        map.addControl(searchControl);
        map.on('dblclick', (ev) => {
          if (checkMarker(ev.latlng.lat, ev.latlng.lng)) {
            setModel({
              latitude: ev.latlng.lat,
              longitude: ev.latlng.lng
            });
          }
        });
        map.on('click', (ev) => {
          if (checkMarker(ev.latlng.lat, ev.latlng.lng)) {
            setModel({
              latitude: ev.latlng.lat,
              longitude: ev.latlng.lng
            });
          }
        });
        if (!posMarker && model.latitude && model.longitude && propHasValue(model.latitude) && propHasValue(model.longitude)) {
          setPosMarker(L.marker([model.latitude, model.longitude], {
            icon: icon
          }).addTo(map))
        }
      } else {
        if (!posMarker && model.latitude && model.longitude && propHasValue(model.latitude) && propHasValue(model.longitude)) {
          setPosMarker(L.marker([model.latitude, model.longitude], {
            icon: icon
          }).addTo(mapClass))
        }
        if (searchValue) {
          searchForLocation(mapClass);
        }
      }
    }, 500)
  }
  const searchForLocation = (map) => {
    let zoom = map.getZoom() ? map.getZoom() : 11;
    if (searchValue && searchValue !== '') {
      mapProvider.search({ query: searchValue }).then((results) => {
        let checkMyLoc = true;
        if (results && results.length > 0) {
          const result = results.find(r => r.raw && r.raw.lat && r.raw.lon);
          if (result) {
            checkMyLoc = false
            map.setView([result.raw.lat, result.raw.lon], zoom);
          }
        }
        if (checkMyLoc) {
          map.locate({ setView: true, watch: true, maxZoom: 18 });
          map.on('locationfound', (ev) => {
            map.setView([ev.latlng.lat, ev.latlng.lng], zoom);
          })
        }
      });
    } else {
      map.locate({ setView: true, watch: true, maxZoom: 18 });
      map.on('locationfound', (ev) => {
        map.setView([ev.latlng.lat, ev.latlng.lng], zoom);
      })
    }
  }
  return <Styles>
    <Space>
      <InputNumber
        max={85}
        min={-85}
        size="large" allowClear={allowClear} type="number" value={model.latitude} onChange={(ev) => {
          if (!ev && typeof ev !== 'number') {
            setModel({
              latitude: undefined,
              longitude: undefined,
            });
            onChange(null);
          } else {
            setModel({
              latitude: ev,
              longitude: model.longitude,
            });
          }
        }} placeholder="Latitude" />
      <InputNumber size="large" allowClear={allowClear} type="number" value={model.longitude} onChange={(ev) => {
        if (!ev && typeof ev !== 'number') {
          setModel({
            latitude: undefined,
            longitude: undefined,
          });
          onChange(null);
        } else {
          setModel({
            longitude: ev,
            latitude: model.latitude,
          });
        }
      }}
        max={180}
        min={-180}
        placeholder="Longitude" />
      <Popover
        content={<div style={{ display: "flex", flexDirection: "column" }}>
          <Alert message={i18next.t('GPS Info')} type="info" style={{ marginBottom: '12px', maxWidth: '800px' }} />
          <div id={mapId} style={{ width: '100%', height: '450px' }}>
          </div>
          <Button onClick={() => setMapVisible(false)} style={{ width: '100%', marginTop: '12px' }} type="dashed" disabled={!propHasValue(model.latitude) || !propHasValue(model.longitude)} icon={<SaveOutlined style={{ verticalAlign: '0px' }} />} >{i18next.t('Save')}</Button>
        </div>}
        placement="topRight"
        open={mapVisible}
        trigger="click"
        onOpenChange={() => setMapVisible((prev) => !prev)}>
        <Button className="open-map" size="large" icon={<SendOutlined rotate="225" />} onClick={() => {
          setMapVisible(true);
        }}>{i18next.t('Find on map')} </Button>
      </Popover>
    </Space>
  </Styles>
}
